import { SelectionSetId } from './../../../../enums/selection-set-id.enum';
import { LeafletGeoJsonLayerComponent } from './../../../../widgets/leaflet-map/leaflet-blocks/leaflet-geo-json-layer/leaflet-geo-json-layer.component';
import { MinifiedSelection } from './../../../../widgets/minified-selections/models/minified-selection-model';
import { CoreService } from './../../../../services/core.service';
import { MapService } from './../map.service';
import { ColorUtils } from './../../../../models/utils';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { SettingsService } from 'src/app/pages/settings/settings.service';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { NotificationService } from 'src/app/services/notification.service';

import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';


import { CoreSetting } from 'src/app/pages/settings/settings.service';
import { PathOptions, StyleFunction } from 'leaflet';


import { Layer } from 'node_modules/@types/leaflet/index.d';
import * as geojson from 'geojson';
import { LeafletCircleMarker } from 'src/app/widgets/leaflet-map/leaflet-blocks/leaflet-circle-marker/models/leaflet-circle-marker.model';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { CryptoRandomFloat } from 'src/app/common/crypto-random-float';

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
    standalone: false
})
export class MapComponent implements OnInit {//, AfterContentInit {
	// <General>
	private readonly _componentTitle = "Map";

	// private readonly _QueryParamName = "NONE";
	// </General>

	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
			{
				baseSelectStatementId: BaseSelectStatementId.MapData,
				selectionSetId: SelectionSetId.MapFilters,
			}
		)
	);



	private _circleMarkerSizeMultiplier: number;

	private initializeCoreSettings(): Promise<CoreSetting> {
		const $this = this;

		const getCoreSettingObservable$ = this._settingsService.getCoreSetting(null, 'MapBubbleSizeMultiplier', true, {
			name: "getCoreSetting",
			showLoadingIndicator: true,
			responseLoggingEnabled: false
		});

		getCoreSettingObservable$.then(
			(response) => {
				if (response && !Number.isNaN(+response.value)) {
					$this._circleMarkerSizeMultiplier = +response.value;
				}
			}
		);

		return getCoreSettingObservable$;
	}

	public forecastTypeList: string[] = ["Final1", "Final2", "Final3"];
	public selectedForecastType: string = this.forecastTypeList[2];

	public onForecastTypeChanged(event) {
		this.selectedForecastType = event.selectedItem;

		this.initializeMapData();
	}

	//#region <Countries Overlay>

	@ViewChild("leafletGeoJSONLayerComponent") private _leafletGeoJSONLayerComponent: LeafletGeoJsonLayerComponent;

	private arrayIndexOf<TValue>(array: any[], value: TValue, predicate?: (value: any) => TValue): number {

		for (let a = 0; a < array.length; a++) {
			let element: any = array[a];

			if (predicate) {
				element = predicate(element);
			}

			if (element === value) {
				return a;
			}
		}

		return -1;
	}

	private _geoStyleData: { ISO3: string, fillColor: string }[];

	public geoStyle: PathOptions | StyleFunction<any> | undefined = (feature) => {

		const indexOfStyle = this.arrayIndexOf(this._geoStyleData, feature.properties.ISO3, (value) => value.ISO3);

		if (indexOfStyle > -1) {
			return {
				fillColor: this._geoStyleData[indexOfStyle].fillColor,
				weight: 1,
				opacity: 1,
				color: "white",
				dashArray: '3',
				fillOpacity: 0.6
			}
		}

		return {
			color: "rgba(0, 0, 0, 0)",
			fillOpacity: 0
		}
	};

	public onEachFeatureCountryOutline(e: {feature: geojson.Feature<geojson.GeometryObject, any>, layer: Layer}) {

		const indexOfStyle = this.arrayIndexOf(this._geoStyleData, e.feature.properties.ISO3, (value) => value.ISO3);

		if (indexOfStyle > -1) {
			e.layer.on(
				{
					mouseover: (leafletEvent) => {
						leafletEvent.target.setStyle(
							{
								weight: 3,
								fillOpacity: 0.8
							}
						);
					},
					mouseout: (leafletEvent) => {
						leafletEvent.target.setStyle(
							{
								weight: 1,
								fillOpacity: 0.6
							}
						);

					},
					click: (leafletEvent) => {

					}
				}
			);
		}
	}

	//#endregion

	public circleMarkersData: LeafletCircleMarker[] = [];
	public circlesData: LeafletCircleMarker[] = [];
	public arcsData: any[] = [];

	private initializeMapData(): void {

		for (let a = 0; a < 100; a++) {
			this.circlesData.push(
				{
					latitude: Math.ceil(CryptoRandomFloat.getCryptoRandomFloat() * 90) * (Math.round(CryptoRandomFloat.getCryptoRandomFloat()) ? 1 : -1),
					longitude: Math.ceil(CryptoRandomFloat.getCryptoRandomFloat() * 180) * (Math.round(CryptoRandomFloat.getCryptoRandomFloat()) ? 1 : -1),

					radius: CryptoRandomFloat.getCryptoRandomFloat() * 50000 + 200
				}
			);
		}

		const $this = this;

		let minifiedSelections: MinifiedSelection[] = [
			new MinifiedSelection(this.selectedForecastType, true, 0, 4)
		];

		this._coreService.getSelectStatementData(
				new SelectStatementOptions(
					{
						minifiedSelections: minifiedSelections,
						filters: this.pageFiltersOperator.appliedFilters,
						baseSelectStatementId: BaseSelectStatementId.MapData,
						selectionSetId: SelectionSetId.MapData,
						periodType: this.selectedPeriodType
					}
				),
				{
					name: "initializeMapData",
					showLoadingIndicator: true,
					responseLoggingEnabled: false,
				}
			).then(
				(promiseResponse) => {
					promiseResponse.subscribe(
						(response) => {
							// <Bubbles>
							let maxFinalForecast: number = Math.max(...(response.data.map(x => x[this.selectedForecastType])));

							$this._geoStyleData = [];
							$this.circleMarkersData = [];

							for (let a = 0; a < response.data.length; a++) {

								const data = response.data[a];



								const t: number = (data[this.selectedForecastType] / maxFinalForecast);

								$this.circleMarkersData.push(
									{
										// circleMarkerData.CountryCode
										latitude: data.Latitude,
										longitude: data.Longitude,

										radius: t * this._circleMarkerSizeMultiplier,

										color: ColorUtils.lerpColor("#e6e8ff", "#17517e", t),

										tooltipHTML: `Final Forecast ${data[this.selectedForecastType]}`,
									}
								);

								$this._geoStyleData.push({ ISO3: data.CountryCode, fillColor: ColorUtils.lerpColor("#e6e8ff", "#17517e", t) });


							}




							// </Bubbles>
						}
					);
				}
			);
	}

	public selectedQuantityType: string;

	public onQuantityTypeChanged(event) {
		this.selectedQuantityType = event.selectedItem;

		this.pageFiltersOperator.load();

		this.initializeMapData();
	}

	public selectedPeriodType: string;

	public periodTypeList: string[] = [];

	private initializePeriodTypeList(): Promise<string[]> {
		const getListElementsByIdObservable$ = this._coreService.getListElementsById(63);

		getListElementsByIdObservable$.subscribe(
			(response) => {
				this.periodTypeList = response;
				this.selectedPeriodType = this.periodTypeList[0];
			}
		);

		return getListElementsByIdObservable$.toPromise();
	}

	public onPeriodChanged(event) {
		this.selectedPeriodType = event.selectedItem;

		this.pageFiltersOperator.load();

		this.initializeMapData();
	}

	constructor(
		private _notificationService: NotificationService,
		private _titleService: Title,
		private _settingsService: SettingsService,
		@Inject(DOCUMENT) private document: Document,
		private _mapService: MapService,
		private _coreService: CoreService,
	) { }

	// ngAfterContentInit(): void {
	// }

	ngOnInit() {
		this._titleService.setTitle(this._componentTitle);

		this.pageFiltersOperator.load();

		this.initializePeriodTypeList(); //TODO: Add a counter before `this.initializeMapData();` to load it only after all of the other required requests have finished loading.

		this.initializeCoreSettings().then(
			(coreSetting) => {
				this.initializeMapData();

				this.pageFiltersOperator.onFiltersApplied.subscribe(
					(selection) => this.initializeMapData()
				);
			}
		);
	}
}
